const form = document.getElementById('contact-form');
const thanks = document.getElementById('contact-thanks');

form.addEventListener('submit', (e) => {
  e.preventDefault();

  const form = event.target;
  const formData = new FormData(form);

  fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams(formData).toString()
  })
    .then(() => {
      form.hidden = true;
      thanks.hidden = false;
    })
    .catch(error => console.log(error));
});

// Hero cursor-following glow
const hero = document.getElementById('hero');

hero.addEventListener('mousemove', (e) => {
  const rect = hero.getBoundingClientRect();
  hero.style.setProperty('--glow-x', `${Math.round(e.clientX - rect.left)}px`);
  hero.style.setProperty('--glow-y', `${Math.round(e.clientY - rect.top)}px`);
  hero.style.setProperty('--glow-opacity', '1');
});

hero.addEventListener('mouseleave', () => {
  hero.style.setProperty('--glow-opacity', '0');
});
